<template>
  <div v-observe-visibility="{callback: visibility,once: true}" class="booking-dates booking-step js-booking-step" v-show="this.$options._componentTag === this.getCurrentStep" :id="this.$options._componentTag">
    <h1 class="booking-title">{{ datesStepTitle }}</h1>
    <div class="booking-steps__wrap js-booking-steps-wrap">
      <div class="booking-steps__wrap-upper">
        <div class="booking-steps__wrap-upper-container" v-if="frequency === 2">
          <div class="booking-steps__wrap-upper-up">
            <span class="booking-label">How often do you want your cleaning?</span>
            <span class="val-error js-date-error">Please select required fields.</span>
            <div class="booking-steps__wrap-upper-btns js-testara">
              <div class="booking-steps__wrap-upper-btns-wrap" :class="{'is-active':often ==='twiceAweek'}">
                <a class="booking-steps__btn js-booking-steps__btn" href="javascript:;" value="twiceAweek" id="twiceAweek" @click="setOften($event)">Twice
                  a Week</a>
              </div>
              <div class="booking-steps__wrap-upper-btns-wrap" :class="{'is-active':often ==='weekly'}">
                <a class="booking-steps__btn js-booking-steps__btn" href="javascript:;" value="weekly" id="weekly" @click="setOften($event)">Weekly</a>
                <span class="booking-steps__wrap-upper-btns-text">10% off</span>
              </div>
              <div class="booking-steps__wrap-upper-btns-wrap" :class="{'is-active':often ==='biWeekly'}">
                <a class="booking-steps__btn js-booking-steps__btn" href="javascript:;" value="biWeekly" id="biWeekly" @click="setOften($event)">Bi-Weekly</a>
              </div>
              <div class="booking-steps__wrap-upper-btns-wrap" :class="{'is-active':often ==='monthly'}">
                <a class="booking-steps__btn js-booking-steps__btn" href="javascript:;" value="monthly" id="monthly" @click="setOften($event)">Monthly</a>
                <!--<span class="booking-steps__wrap-upper-btns-text">10% off</span>-->
              </div>
              <!--<div class="booking-steps__wrap-upper-btns-wrap" :class="{'is-active':often ==='biMonthly'}">-->
              <!--  <a class="booking-steps__btn js-booking-steps__btn" href="javascript:;" value="biMonthly" id="biMonthly" @click="setOften($event)">Bi-Monthly</a>-->
              <!--</div>-->
            </div>
            <p class="booking-steps__selected-info">{{ oftenMessageDisplay }}</p>
          </div>
          <div :class="['booking-steps__wrap-upper-mid', {'opacity': notActiveDays}]">
            <span class="booking-label">{{ whatDayTitle }}</span>
            <span class="val-error js-date-error2"></span>
            <span class="val-error js-date-error">Please select required fields.</span>
            <div class="booking-steps__wrap-middle-btns">
              <a :class="['booking-steps__wrap-middle-btns-wrap js-days-checkbox', {'is-tooltip': tooltip}, {'disabled': blockedDays.indexOf(key + 1) !== -1}]" ref="tooltip" @click="setDay($event, key, index)" href="javascript:;" v-for="(day, index, key) in days" :key="index" :id="index">{{
                  day
                }}
                <span class="booking-steps__wrap-middle-btns-wrap-tooltip">You can only select {{ tooltipDays }}; uncheck the selection by clicking on it again.</span>
              </a>
            </div>
            <p class="booking-steps__selected-info">{{ daysMessageDisplay }}</p>
          </div>
        </div>
        <!-- calendar -->
        <span v-if="frequency === 2" class="booking-label booking-label--margin-bottom">When should your cleanings start?</span>
        <span class="val-error js-date-error">Please select the starting date.</span>
        <DatePicker
            v-model="calendarDay"
            :disabled-dates="blockedDaysRangeData"
            :attributes='multipleDates'
            :min-date='new Date(Date.now() + (3600 * 1000 * 24))'
        />
        <p class="booking-steps__selected-info" v-if="frequency === 1 && summaryOneTimeRecurringMsg">
          {{ summaryOneTimeRecurringMsg }}</p>
        <p class="booking-steps__selected-info" v-if="frequency === 2 && summaryRecurringMessage !== ''">Summary:
          {{ summaryRecurringMessage }}{{ this.beginningMsg }}</p>
      </div>
      <div class="booking-side__image booking-location__image js-booking-side__image">
        <img class="media-item booking-side__image-firefox" :src="imagesPath" alt="animation">
        <div class="anim-holder">
          <div class="anim-container anim-container--05" ref="animContainer"></div>
        </div>
      </div>
    </div>
    <div class="booking-steps__wrap-bottom js-booking-steps-bottom" v-if="policyText">
      <p class="booking-steps__wrap-bottom-text" v-html="policyText"></p>
    </div>
  </div><!-- .booking-location -->
</template>
<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import {mapGetters} from 'vuex';
import Global from '../../../js/shared/global';
import lottieWeb from 'lottie-web';

export default {
  props: ['blockedDays', 'policyText', 'blockedDaysRange'],
  beforeMount() {
    this.beginningMsg = Global.readCookie('beginningDateMsg');
    this.summaryOneTimeRecurringMsg = Global.readCookie('oneTimeDateMsg');
  },
  mounted() {
    this.animation();
    this.blockedDaysConcat = this.$props.blockedDays;
    const daysBlockedArr = [...this.$props.blockedDaysRange];
    const weekDays = {weekdays: this.blockedDaysConcat};
    daysBlockedArr.push(weekDays);
    this.blockedDaysRangeData = daysBlockedArr;
  },
  data: function() {
    return {
      imagesPath: process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/5.png',
      blockedDaysRangeData: [],
      datesStepTitle: 'Select your booking dates',
      tooltipDays: '',
      multipleDates: [],
      indexes: [],
      activeDays: '',
      weekDays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      today: '',
      sumDay: '',
      sumMonth: '',
      sumDayNum: '',
      sumYear: '',
      datesIndexes: [2],
      myDates: '',
      calendarDay: Global.readCookie('selectedOneTimeDate') !== undefined ? Global.readCookie('selectedOneTimeDate') : '',
      calendarMonth: '',
      often: '',
      daysArr: [],
      flag: false,
      countActiveDaysMultiple: 0,
      tooltip: false,
      oftenMessageDisplay: '',
      daysMessageDisplay: '',
      summaryRecurringMessage: '',
      frequency: null,
      notActiveDays: true,
      notActiveCalendar: true,
      beginningMsg: '',
      weekCount: '',
      oldOften: '',
      summaryOneTimeRecurringMsg: '',
      blockedDaysConcat: [],
      indexDaysNums: [1, 2, 3, 4, 5, 6, 7],
      oftenMessage: {
        twiceAweek: 'Okay, you selected twice a week (two times a week)',
        weekly: 'Okay, you selected weekly (once a week)',
        biWeekly: 'Okay, you selected Bi-weekly (every other week).',
        monthly: 'Okay, you selected monthly (every four weeks)',
        biMonthly: 'Okay, you selected Bi-monthly (every other month).',
      },
      days: {
        sunday: 'S',
        monday: 'M',
        tuesday: 'T',
        wednesday: 'W',
        thursday: 'T',
        friday: 'F',
        saturday: 'S',
      },
      whatDayTitle: 'What day of the week?',
    };
  },
  computed: {
    ...mapGetters([
      'getActiveFrequency',
      'getCurrentStep',
      'getSelectedDateObject',
    ]),
  },
  components: {
    DatePicker
  },
  methods: {
    animation() {
      setTimeout(() => {
        const animContainer = document.getElementsByClassName('anim-container--05');
        let animation;
        animContainer.forEach(function(el) {
          animation = process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/Icon5.json';
          const anim = lottieWeb.loadAnimation({
            container: el,
            animType: 'svg',
            loop: true,
            autoplay: true,
            path: animation,
            renderer: 'svg',
            rendererSettings: {
              progressiveLoad: true,
            },
          });
          anim.play();
        });
      }, 500);
    },
    visibility(isVisible) {
      if (isVisible) {
        this.fillMultiDates();
        this.setSummaryMessage();
      }
    },
    fillMultiDates() {
      const multiDates = Global.readCookie('multiDates');
      if (!multiDates) {
        return;
      }

      const weeks = document.querySelectorAll('.booking-steps__btn');
      const days = document.querySelectorAll('.js-days-checkbox');
      if (weeks) {
        for (let i = 0; i < weeks.length; i++) {
          if (weeks[i].getAttribute('value') === multiDates.often) {
            weeks[i].click();
          }
        }
      }
      if (days) {
        for (let i = 0; i < days.length; i++) {
          // if is in array (use === if is not in array)
          if (multiDates.days.indexOf(days[i].id) !== -1) {
            days[i].click();
          }
        }
      }

    },
    setOften(event) {
      this.blockedDaysConcat = this.$props.blockedDays;
      this.blockedDaysRangeData.splice(-1);
      this.blockedDaysRangeData.push({weekdays: this.blockedDaysConcat});
      this.daysMessageDisplay = '';
      this.summaryRecurringMessage = '';
      this.uncheckAllDays();
      const OftenID = event.currentTarget.id;
      const Messages = this.oftenMessage;
      this.often = OftenID;
      if (this.often === 'twiceAweek') {
        this.whatDayTitle = 'Which days of the week?';
      } else {
        this.whatDayTitle = 'Which day of the week?';
      }
      this.$store.dispatch('setDates', {often: this.often, days: this.day});
      Global.setCookie('howOften', this.often);
      // eslint-disable-next-line consistent-this
      const that = this;
      //Display the message depending on the selected one
      Object.keys(Messages).forEach(function(key) {
        if (OftenID === key) {
          that.oftenMessageDisplay = Messages[key];
        }
      });
      this.notActiveDays = this.often === '';
      const error = document.querySelector('#BlockStepDates .booking-steps__wrap-upper-up .js-date-error');
      if (error) {
        error.style.display = 'none';
      }
    },
    setDay(event, key, day) {
      if (this.flag) {
        this.calendarDay = '';
        Global.setCookie('selectedOneTimeDate', '');
      }
      this.setGetActiveDays(event.currentTarget, 'is-active', day);
      this.removeAllTooltips();
      let daysSelect = 1;
      this.tooltipDays = 'one day';
      if (this.often === 'twiceAweek') {
        daysSelect = 2;
        this.tooltipDays = 'two days';
      }

      if (this.daysArr.length > daysSelect) {
        this.tooltipAlert(event.currentTarget, day);
        this.blockedDaysConcat.push(key + 1);
      } else {
        this.setMultiDates(this.often);
      }
      this.blockedDaysRangeData.splice(-1);
      this.blockedDaysRangeData.push({weekdays: this.blockedDaysConcat});

      this.setDaysMessages();
      const error = document.querySelector('#BlockStepDates .booking-steps__wrap-upper-mid .js-date-error');
      if (error) {
        error.style.display = 'none';
      }
      const error2 = document.querySelector('#BlockStepDates .booking-steps__wrap-upper-mid .js-date-error2');
      if (error2) {
        error2.style.display = 'none';
      }
    },
    setDaysMessages() {
      let msg = '';
      if (this.often === 'twiceAweek') {
        if (this.daysArr.length === 1) {
          msg = `${this.capitalize(this.daysArr[0])}.`;
          this.daysMessageDisplay = `Great, you selected every ${msg}`;
        } else if (this.daysArr.length === 2) {
          msg = `${this.capitalize(this.daysArr[0])} and ${this.capitalize(this.daysArr[1])}.`;
          this.daysMessageDisplay = `Great, you selected every ${msg}`;
        } else {
          this.daysMessageDisplay = '';
        }
      }

      if (this.often === 'weekly') {
        if (this.daysArr.length === 1) {
          msg = `${this.capitalize(this.daysArr[0])}`;
          this.daysMessageDisplay = `Great, you selected every ${msg}.`;
        } else {
          this.daysMessageDisplay = '';
        }
      }

      if (this.often === 'biWeekly') {
        if (this.daysArr.length === 1) {
          msg = `other ${this.capitalize(this.daysArr[0])}`;
          this.daysMessageDisplay = `Great, you selected every ${msg}`;
        } else {
          this.daysMessageDisplay = '';
        }
      }

      if (this.often === 'monthly') {
        if (this.daysArr.length === 1) {
          msg = `fourth ${this.capitalize(this.daysArr[0])}`;
          this.daysMessageDisplay = `Great, you selected every ${this.firstLetterLower(msg)}`;
        } else {
          this.daysMessageDisplay = '';
        }
      }

      if (this.often === 'biMonthly') {
        if (this.daysArr.length === 1) {
          msg = `${this.capitalize(this.daysArr[0])} in every other month.`;
          this.daysMessageDisplay = `Great, you selected every ${msg}`;
        } else {
          this.daysMessageDisplay = '';
        }
      }
    },
    setSummaryMessage() {
      let msg = '';
      if (this.often === 'twiceAweek') {
        if (this.daysArr.length === 1) {
          msg = `Every ${this.capitalize(this.daysArr[0])}`;
          this.summaryRecurringMessage = `Twice a week - ${msg}`;
        } else if (this.daysArr.length === 2) {
          msg = `Every ${this.capitalize(this.daysArr[0])} and ${this.capitalize(this.daysArr[1])}`;
          this.summaryRecurringMessage = `Twice a week - ${msg}`;
        } else {
          this.summaryRecurringMessage = '';
        }
      }

      if (this.often === 'weekly') {
        if (this.daysArr.length === 1) {
          msg = `Every ${this.capitalize(this.daysArr[0])}`;
          this.summaryRecurringMessage = `Weekly - ${msg}`;
        } else {
          this.summaryRecurringMessage = '';
        }
      }

      if (this.often === 'biWeekly') {
        if (this.daysArr.length === 1) {
          msg = `Every other ${this.capitalize(this.daysArr[0])}`;
          this.summaryRecurringMessage = `Bi-weekly - ${this.capitalize(msg)}`;
        } else {
          this.summaryRecurringMessage = '';
        }
      }

      if (this.often === 'monthly') {
        const _this = this;
        setTimeout(function() {
          const activeDay = document.querySelector('.vc-highlights.vc-day-layer');
          if (activeDay) {
            if (activeDay.parentElement.classList.contains('weekday-ordinal-from-end-4')) {
              _this.weekCount = 'first';
            }
            if (activeDay.parentElement.classList.contains('weekday-ordinal-from-end-3')) {
              _this.weekCount = 'second';
            }
            if (activeDay.parentElement.classList.contains('weekday-ordinal-from-end-2')) {
              _this.weekCount = 'third';
            }
            if (activeDay.parentElement.classList.contains('weekday-ordinal-from-end-1')) {
              _this.weekCount = 'fourth';
            }
            if (_this.daysArr.length === 1) {
              msg = `Every four weeks on ${_this.capitalize(_this.daysArr[0])}`;
              _this.summaryRecurringMessage = `Monthly - ${msg}`;
            } else {
              _this.summaryRecurringMessage = '';
            }
          }

        }, 200);
      }

      // if (this.often === 'biMonthly') {
      //   const _this = this;
      //   setTimeout(function() {
      //     const activeDay = document.querySelector('.vc-highlights.vc-day-layer');
      //     if (activeDay.parentElement.classList.contains('weekday-ordinal-from-end-4')) {
      //       _this.weekCount = 'first';
      //     }
      //     if (activeDay.parentElement.classList.contains('weekday-ordinal-from-end-3')) {
      //       _this.weekCount = 'second';
      //     }
      //     if (activeDay.parentElement.classList.contains('weekday-ordinal-from-end-2')) {
      //       _this.weekCount = 'third';
      //     }
      //     if (activeDay.parentElement.classList.contains('weekday-ordinal-from-end-1')) {
      //       _this.weekCount = 'fourth';
      //     }
      //     if (_this.daysArr.length === 1) {
      //       msg = `${_this.capitalize(_this.daysArr[0])} in every other month.`;
      //       const msgCal = `Every other month, on the fourth ${_this.capitalize(_this.daysArr[0])}`;
      //       _this.summaryRecurringMessage = `Bi-monthly - ${msgCal}`;
      //     } else {
      //       _this.summaryRecurringMessage = '';
      //     }
      //   }, 200);
      // }
    },
    capitalize(s) {
      if (typeof s !== 'string') return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    firstLetterLower(s) {
      if (typeof s !== 'string') return '';
      return s.charAt(0).toLowerCase() + s.slice(1);
    },
    setGetActiveDays(target, classType, day) {
      this.indexes = [];
      // check/uncheck days
      if (target.classList.contains(classType)) {
        // unset active days
        const index = this.daysArr.indexOf(day);
        this.daysArr.splice(index, 1);
      } else {
        // set active days
        this.daysArr.push(day);
      }

      // set calendar active days
      for (let i = 0; i < this.daysArr.length; i++) {
        const index = this.weekDays.indexOf(this.daysArr[i]);
        this.indexes.push(index + 1);
      }
      this.blockedDaysConcat = this.indexDaysNums.filter(x => !this.indexes.includes(x));
      this.blockedDaysRangeData.splice(-1);
      this.blockedDaysRangeData.push({weekdays: this.blockedDaysConcat});
      // toggle active class
      target.classList.toggle(classType);
    },
    tooltipAlert(el, day) {
      const index = this.daysArr.indexOf(day);
      this.daysArr.splice(index, 1);
      el.classList.remove('is-active');
      el.classList.add('is-tooltip');
    },
    removeAllTooltips() {
      const tooltipDay = this.$refs.tooltip;
      if (tooltipDay) {
        for (let i = 0; i < tooltipDay.length; i++) {
          tooltipDay[i].classList.remove('is-tooltip');
        }
      }
    },
    setMultiDates(often) {
      let weekInterval = 1;
      let monthlyInterval = 1;
      if (often === 'twiceAweek' || often === 'weekly') {
        weekInterval = 1;
      }

      if (often === 'biWeekly') {
        weekInterval = 2;
      }

      if (often === 'monthly') {
        weekInterval = 4;
      }

      if (often === 'biMonthly') {
        monthlyInterval = 2;
      }

      this.multipleDates = [
        {
          dates: {weekdays: this.indexes, weeklyInterval: weekInterval, monthlyInterval: monthlyInterval},
          highlight: false
        },
      ];

      // save object in cookie so we can preselect options in parent file
      const multiDates = {
        'often': this.often,
        'days': this.daysArr,
        'frequency': this.frequency,
        'requiredDays': this.often === 'twiceAweek' ? 2 : 1,
        'startDay': Global.readCookie('selectedOneTimeDate'),
      };
      Global.setCookie('multiDates', multiDates);
      this.$store.dispatch('setMultiDatesObj', multiDates);
    },
    uncheckAllDays() {
      // uncheck all days
      const daysCheckboxes = document.querySelectorAll('.js-days-checkbox.is-active');
      if (daysCheckboxes) {
        for (let i = 0; i < daysCheckboxes.length; i++) {
          daysCheckboxes[i].classList.remove('is-active');
        }
      }
      // clear calendar
      this.clearCalendar();
      this.removeAllTooltips();
    },
    clearCalendar() {
      this.indexes = [];
      this.daysArr = [];
      // clear calendar
      this.multipleDates = [
        {
          dates: {weekdays: this.indexes},
          highlight: false
        },
      ];
    },
  },
  watch: {
    calendarDay: function(newVal) {
      const error = document.querySelector('#BlockStepDates .booking-steps__wrap-upper > .js-date-error');
      const errors = document.querySelectorAll('#BlockStepDates .js-date-error');
      Global.setCookie('selectedOneTimeDate', '');
      if (!newVal) {
        error.style.display = 'block';
        return false;
      }

      if (error) {
        error.style.display = 'none';
      }
      if (errors) {
        for (let i = 0; i < errors.length; i++) {
          errors[i].style.display = 'none';
        }
      }
      this.setSummaryMessage();
      Global.setCookie('selectedOneTimeDate', newVal);
      const day = newVal.getDate();
      const year = newVal.getFullYear();
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      const monthName = monthNames[newVal.getMonth()];
      const dayName = days[newVal.getDay()];
      this.$store.dispatch('setOneDayDate', monthName + ' ' + day + ', ' + year);
      Global.setCookie('oneDayDateTime', monthName + ' ' + day + ', ' + year);
      const activeProduct = this.$store.getters['getActiveProduct'];
      this.$store.dispatch('setSelectedDateObject', {
        'monthName': monthName,
        'monthNumber': newVal.getMonth() + 1,
        'dayName': dayName,
        'day': day,
        'year': year,
        'activeProductId': activeProduct.id
      });
      this.beginningMsg = ', beginning ' + monthName + ' ' + Global.ordinal(day) + ', ' + year;
      this.summaryOneTimeRecurringMsg = 'Summary: ' + dayName + ', ' + monthName + ' ' + Global.ordinal(day) + ' ' + year;
      Global.setCookie('beginningDateMsg', this.beginningMsg);
      Global.setCookie('oneTimeDateMsg', this.summaryOneTimeRecurringMsg);
    },
    frequency(newVal, oldVal) {
      const step = this.getCurrentStep;
      if (step === 'BlockStepDates') {
        if (newVal) {
          if (newVal !== oldVal) {
            Global.setCookie('selectedOneTimeDate', '');
            Global.setCookie('beginningDateMsg', '');
            Global.setCookie('oneTimeDateMsg', '');
            this.blockedDaysConcat = this.$props.blockedDays;
            this.blockedDaysRangeData.splice(-1);
            this.blockedDaysRangeData.push({weekdays: this.blockedDaysConcat});
            this.calendarDay = '';
            this.beginningMsg = '';
            this.summaryRecurringMessage = '';
            this.summaryOneTimeRecurringMsg = '';
          }
        }
      }
      if (newVal === 1) {
        this.clearCalendar();
      }

      this.notActiveCalendar = newVal !== 1;
    },
    often(newVal, oldVal) {
      console.log(newVal, oldVal);
      this.$store.dispatch('setTotal', {often: newVal, oldOften: oldVal});
      Global.setCookie('howOften', newVal);
      Global.setCookie('oldOften', oldVal);
      if (this.flag) {
        if (newVal !== oldVal) {
          this.calendarDay = '';
          Global.setCookie('selectedOneTimeDate', '');
        }
      }
      this.flag = true;
    }
  },
  updated() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been re-rendered
      const frequency = Global.readCookie('frequency');
      if (frequency) {
        this.frequency = frequency;
      }
      if (this.frequency === 1) {
        this.datesStepTitle = 'Select your booking date';
      } else {
        this.datesStepTitle = 'Select your booking dates';
      }
      const dateObj = this.getSelectedDateObject;
      if (!Global.isEmptyObject(dateObj)) {
        this.sumDay = dateObj.dayName;
        this.sumMonth = dateObj.monthName;
        this.sumDayNum = Global.ordinal(dateObj.day);
        this.sumYear = dateObj.year;
      }
    });
  }
};
</script>
<style lang="scss" scoped>

.booking-dates {

  .booking-label {
    font-size: 20px;
    letter-spacing: 4px;
    margin-bottom: 0;

    span {
      color: $tree-poppy;
    }

    @include mq($lg) {
      margin-bottom: 15px;
    }

    @include mq($md) {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
}

.booking-steps__wrap-upper {
  max-width: 750px;
  padding-top: 50px;

  @include mq($lap-mid) {
    max-width: 650px;
  }

  @include mq($lap-large) {
    max-width: 60%;
  }

  @include mq($xl) {
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 0;
  }
}

.booking-steps__wrap-upper-container {
  width: 100%;

  @include mq($lg) {
    overflow: hidden;
  }
}

.booking-steps__wrap-upper-up {
  width: 100%;
}

.booking-steps__wrap-upper-btns {
  margin: -10px -15px 0;

  @include mq($desk-mini) {
    margin: 0 -15px 0;
  }

  @include mq($xl) {
    justify-content: space-between;
    margin: 0;
  }
}

.booking-steps__wrap-upper-btns-wrap {
  margin: 41px 15px 0;

  @include mq($desk-mini) {
    margin: 30px 15px 0;
  }

  @include mq($xl) {
    margin: 30px 0 0;
    width: 48%;
  }

  @include mq($md) {
    margin: 15px 0 0;
  }
}

.booking-steps__btn {

  @include mq($xl) {
    min-width: 100%;
  }
}

.booking-steps__wrap-middle-btns {
  margin: 31px -15px 0;

  @include mq($md) {
    justify-content: space-between;
    margin: 15px 0 0;
  }
}

.booking-steps__wrap-middle-btns-wrap {
  margin: 0 15px;

  @include mq($md) {
    margin: 10px 5px 0;
  }

  @include mq($xs) {
    margin: 10px 2px 0;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

.vc-container {
  max-width: 750px;
  width: 100%;
  background-color: #3f78ec;
  border: none;
  color: white;
  font-weight: bold;
  font-size: 20px !important;

  @include mq(1300px) {
    max-width: 95%;
  }
  @include mq($xl) {
    max-width: 100%;
  }
}

.opacity {
  opacity: 0.5;
  pointer-events: none;
}

.booking-steps__wrap-upper-mid {
  margin: 40px 0;

  @include mq($xl) {
    margin: 40px 0 20px;
  }
}

.booking-label--margin-bottom {
  margin-bottom: 31px !important;
}

.booking-steps__wrap-bottom {
  width: 100%;
  margin-top: 60px;

  @include mq($lap-large) {
    margin-top: 40px;
  }

  @include mq($xl) {
    margin-top: 20px;
  }
}

.booking-steps__wrap-bottom-text {
  font-size: 20px;
  font-family: $font-main;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.1px;
  line-height: 44px;
  color: $white;
  max-width: 750px;

  @include mq($xl) {
    max-width: 100%;
  }

  @include mq($lg) {
    font-size: 19px;
    line-height: 1.7;
  }

  @include mq($md) {
    font-size: 18px;
  }

  @include mq($phone) {
    font-size: 15px;
  }

  br {

    @include mq($xl) {
      display: none;
    }
  }
}

.booking-location__image {
  margin: 0 auto !important;

  @include mq($lap-large) {
    max-width: 40%;
    margin: 40px auto !important;
    img {
      margin: 0 auto;
    }
  }

  @include mq($lg) {
    max-width: 300px;
    margin: 0 auto !important;
  }
}

.booking-steps__selected-info {
  @include mq($xl) {
    margin-bottom: 0;
  }
}
</style>
